import React, { useContext, useEffect } from "react";
import { Container } from "react-bootstrap";
import { withRouter } from "react-router-dom";
import { I18nContext } from "../../i18n";
import PersonInfo from "../common/PersonInfo";
import CorrespondenceInfo from "../common/CorrespondenceInfo";
import BasicInfo from "./OppBasicInfo";
import DetailedInfo from "./OppDetailedInfo";
import MobileNavbar from "../../components/header/MobileNavbar";
import ExpandedNavbar from "../../components/header/ExpandedNavbar";
import UseWindowSize from "../../customHooks/useWindowSize";
import { formatDate } from "../../helpers/helpers";
import { bootStrapGrid } from "../../constants/constants";
import PageNotFound from "../errors/PageNotFound";


const Opposition = (props) => {
  const { translate } = useContext(I18nContext);
  const size = UseWindowSize();
  document.title = translate("application_title_opposition") + " | PRH";
  const data = props.opposition.data;

  const basicInfo = {
    applicationNumber: data.applicationNumber,
    oppositionType: data.oppositionType,
    applicationDate: formatDate(data.applicationDate),
    dossierStatus: data.dossierStatus,
  };

  const detailedInfo = {
    relatedTrademarks: data.relatedTrademarks,
    oppositionGrounds: data.oppositionGrounds,
  };

  useEffect(() => {
    props.pathParams.updateLanguage();
    props.fetchOpposition(
      "trademark/opposition/" + props.match.params.applicationNumber
    );
  }, []);

  if (data.length < 1) {
    if(props.opposition.error)
      return (<PageNotFound title="trademark_not_found" description="trademark_not_found_description"/>);

    return null;
  }

  return (
    <div>
      <div id="skip">
        <a href="#opp_content">{translate("jumplink_to_content")}</a>
      </div>
      {size.width < bootStrapGrid.md ? (
        <MobileNavbar pathParams={props.pathParams} />
      ) : (
        <ExpandedNavbar pathParams={props.pathParams} />
      )}
      <main id="opp_content" tabIndex="-1">
        <Container className={"mt-4 mb-4"}>
          <BasicInfo data={basicInfo} />
          <DetailedInfo data={detailedInfo} pathParams={props.pathParams} />
          <PersonInfo
            title={translate("trademark.portlet.applicant.registered")}
            persons={data.applicants}
          />
          <PersonInfo
            title={translate("trademark.portlet.representative")}
            persons={data.representatives}
          />
          <PersonInfo
            title={translate("trademark_opposition_opponents")}
            persons={data.opponents}
          />
          <PersonInfo
            title={translate("trademark_opposition_opponent_representatives")}
            persons={data.opponentRepresentatives}
          />
          <CorrespondenceInfo data={data.correspondence} />
        </Container>
      </main>
    </div>
  );
};

export default withRouter(Opposition);
